// extracted by mini-css-extract-plugin
export default {"innerContent":"style_innerContent__lKMJh","buttonNext":"style_buttonNext__e1D2m","parentInput":"style_parentInput__0Whw5","input":"style_input__FGL+j"};